module.exports = __webpack_public_path__ + "media/images/dashboards/activity-e80aed478b30fddaa086f0f975565e30.png";